import axios from "axios";
import Config from "../../config/index";
import {
  CREATE_NEW_RESOURCE_GROUP_FAILURE,
  CREATE_NEW_RESOURCE_GROUP_REQUEST,
  CREATE_NEW_RESOURCE_GROUP_SUCCESS,
  DELETE_RESOURCE_GROUP_FAILURE,
  DELETE_RESOURCE_GROUP_REQUEST,
  DELETE_RESOURCE_GROUP_SUCCESS,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST,
  GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS,
  GET_RESOURCE_GROUP_FAILURE,
  GET_RESOURCE_GROUP_REQUEST,
  GET_RESOURCE_GROUP_SUCCESS,
  UPDATE_RESOURCE_GROUP_FAILURE,
  UPDATE_RESOURCE_GROUP_REQUEST,
  UPDATE_RESOURCE_GROUP_SUCCESS,
} from "./resourceGroupScreenTypes";

let baseUrl = Config.baseUrl;

// ------------------------ Get All ------------------------
const getResourceGroup = (jwtToken) => {
  const headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch({ type: GET_RESOURCE_GROUP_REQUEST });
    axios
      .get(`${baseUrl}/workcenter`, headers)
      .then((res) => {
        dispatch({ type: GET_RESOURCE_GROUP_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        dispatch({ type: GET_RESOURCE_GROUP_FAILURE, payload: err.response });
      });
  };
};

// // ------------------------ Create ------------------------
const createNewResourceGroup = (payload, jwtToken) => {
  const headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  // console.log("Sending Payload to Backend:", payload);
  // console.log("POST URL:", `${baseUrl}/workcenter`);
  return (dispatch) => {
    dispatch({ type: CREATE_NEW_RESOURCE_GROUP_REQUEST });
    return axios
      .post(`${baseUrl}/workcenter`, payload, headers)
      .then((res) => {
        dispatch({
          type: CREATE_NEW_RESOURCE_GROUP_SUCCESS,
          payload: res.data,
        });
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch({
          type: CREATE_NEW_RESOURCE_GROUP_FAILURE,
          payload: err.response,
        });
        return { status: false, data: err.response };
      });
  };
};

// ------------------------ Update ------------------------
const updateResourceGroup = (payload, jwtToken) => {
  const headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch({ type: UPDATE_RESOURCE_GROUP_REQUEST });
    return axios
      .put(`${baseUrl}/workcenter`, payload, headers)
      .then((res) => {
        dispatch({ type: UPDATE_RESOURCE_GROUP_SUCCESS, payload: res.data });
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_RESOURCE_GROUP_FAILURE,
          payload: err.response,
        });
        return { status: false, data: err.response };
      });
  };
};

// ------------------------ Delete ------------------------
const deleteResourceGroup = (
  workCenterId,
  userId,
  woCode,
  locationId,
  jwtToken,
) => {
  const headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch({ type: DELETE_RESOURCE_GROUP_REQUEST });
    const url = `${baseUrl}/workcenter?workCenterId=${workCenterId}&userId=${userId}&woCode=${woCode}&locationId=${locationId}`;
    return axios
      .delete(url, headers)
      .then((res) => {
        dispatch({ type: DELETE_RESOURCE_GROUP_SUCCESS, payload: res.data });
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch({
          type: DELETE_RESOURCE_GROUP_FAILURE,
          payload: err.response,
        });
        return { status: false, data: err.response };
      });
  };
};

const getLocationsForResourceGroupRequest = () => {
  return {
    type: GET_LOCATIONS_FOR_RESOURCE_GROUP_REQUEST,
  };
};

const getLocationsForResourceGroupSuccess = (payload) => {
  return {
    type: GET_LOCATIONS_FOR_RESOURCE_GROUP_SUCCESS,
    payload: payload,
  };
};

const getLocationsForResourceGroupFailure = (error) => {
  return {
    type: GET_LOCATIONS_FOR_RESOURCE_GROUP_FAILURE,
    payload: error,
  };
};

const getLocationsForResourceGroup = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLocationsForResourceGroupRequest());

    let url = `${baseUrl}/location_wc`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLocationsForResourceGroupSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLocationsForResourceGroupFailure(err.message));
      });
  };
};

// const getDownloadResourceGroup = (jwtToken) => {
//   const headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch({ type: GET_DOWNLOAD_RESOURCE_GROUP_REQUEST });

//     let url = `${baseUrl}/workcenter?download=1`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch({
//           type: GET_DOWNLOAD_RESOURCE_GROUP_SUCCESS,
//           payload: response.data,
//         });
//       })
//       .catch((err) => {
//         dispatch({
//           type: GET_DOWNLOAD_RESOURCE_GROUP_FAILURE,
//           payload: err.response,
//         });
//       });
//   };
// };

export {
  createNewResourceGroup,
  deleteResourceGroup,
  getLocationsForResourceGroup,
  getResourceGroup,
  updateResourceGroup,
};
